<template>
  <div class="main">
    <div class="banner">
      <slot name="image"></slot>
      <div class="tag" v-if="title.eng || title.chs">
        <div class="eng">
          <span class="title_eng">{{ title.eng }}</span>
        </div>
        <div class="chs">
          <span class="title_chs">{{ title.chs }}</span>
        </div>
      </div>
    </div>
    <div class="nav" :style="{ backgroundColor: bgColor }" v-if="navShow">
      <slot name="nav"></slot>
    </div>
    <!-- 锯齿边平铺 -->
    <div class="split" v-if="navShow"></div>
  </div>
</template>
<script>
export default {
  props: {
    bgColor: {
      type: String,
      default: '#d2d2d2',
    },
    title: {
      type: Object,
      default: () => {
        return {
          eng: '',
          chs: '',
        }
      },
    },
    navShow: {
      type: Boolean,
      default: true,
    },
  },
}
</script>
<style lang="stylus" scoped>
.main
  .banner
    max-height 650px
    position relative
  .nav
    width 100%
    padding 30px 0
  .split
    height 8px
    width 100%
    background-image url('~@/assets/images/split_top.jpg')
    background-repeat repeat-x
    background-position 0px -115px
  .tag
    position absolute
    width 1340px
    top 50%
    left 50%
    transform translate(-50%, -50%)
    .eng, .chs
      color #fff
      text-align left
      line-height 1
    .eng
      margin-bottom 12px
      .title_eng
        font-family 'Arial-BoldItalicMT'
        font-size 42px
        font-weight bold
        font-style oblique
        letter-spacing 2px
        opacity 0.75
    .chs
      .title_chs
        font-size 32px
        font-weight bold
        letter-spacing 1px
        opacity 0.75
</style>
